import React from "react";
import { AHText, AHTextFonts, Box } from "arkh";
import { useTime } from "../../useTime";
import { DateTime } from "luxon";

export function Clock() {
  const time = useTime(6000);
  return (
    <Box style={{ flexDirection: "row" }}>
      <AHText type="title-big">
        <AHText
          type="title-big"
          color="text-secondary"
          style={{
            fontVariant: ["tabular-nums"],
          }}
        >
          {time.toLocaleString({
            ...DateTime.DATE_MED_WITH_WEEKDAY,
            year: undefined,
          })}
        </AHText>{" "}
        <AHText
          type="title-big"
          style={{
            fontVariant: ["tabular-nums"],
          }}
        >
          {time.toFormat("HH:mm")}
        </AHText>
      </AHText>
    </Box>
  );
}
